"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _AccountCircle2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AccountCircle"));
var _context = require("../../../services/auth/context");
var _context2 = require("../services/context");
var _usePublishLoginButtonClicked = _interopRequireDefault(require("../../../components/MagicLogin/consts/events/business/usePublishLoginButtonClicked"));
var _jsxRuntime = require("react/jsx-runtime");
var _AccountCircle, _FormattedMessage;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SignInButton = () => {
  const {
    onOpenModal
  } = (0, _context.useAuth)();
  const {
    isSignInShown
  } = (0, _context2.useNavConfig)();
  const publishLoginButtonClicked = (0, _usePublishLoginButtonClicked.default)();
  const handleSignInClick = () => {
    publishLoginButtonClicked("navbar_signin_button");
    onOpenModal({
      triggerRef: ref
    });
  };
  const ref = React.useRef(null);
  if (!isSignInShown) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
    ref: ref,
    onClick: handleSignInClick,
    iconLeft: _AccountCircle || (_AccountCircle = /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountCircle2.default, {
      ariaHidden: true
    })),
    compact: true,
    type: "secondary",
    dataTest: "TopNav-SingInButton",
    children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "navbar.header.sign_in"
    }))
  });
};
var _default = exports.default = SignInButton;